import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0f5dbe1d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "selector-page"
};
const _hoisted_2 = {
  class: "preview"
};
const _hoisted_3 = {
  key: 0,
  class: "board-preview"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "select-action"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LeftGroupList = _resolveComponent("LeftGroupList");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_OpticalPathBoard = _resolveComponent("OpticalPathBoard");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("aside", null, [_createVNode(_component_LeftGroupList, {
    "group-title": "黑盒光路分组",
    data: $data.groups,
    onChoose: $options.onChoose
  }, null, 8, ["data", "onChoose"])]), _withDirectives((_openBlock(), _createElementBlock("main", null, [!$data.loading && $data.questions.length === 0 ? (_openBlock(), _createBlock(_component_el_empty, {
    key: 0,
    description: "当前分组没有可选题目"
  })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.questions, question => {
    return _openBlock(), _createElementBlock("article", {
      key: question.id,
      class: "selector-card"
    }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", null, _toDisplayString(question.title), 1), $options.config(question) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.config(question).cases, (knownCase, caseIndex) => {
      return _openBlock(), _createBlock(_component_OpticalPathBoard, {
        key: `case-${caseIndex}`,
        "model-value": knownCase,
        compact: "",
        "show-elements": false,
        "aria-label": `已知案例 ${caseIndex + 1}`
      }, null, 8, ["model-value", "aria-label"]);
    }), 128)), _createVNode(_component_OpticalPathBoard, {
      "model-value": $options.config(question).target,
      compact: "",
      "show-elements": false,
      "aria-label": "新射入路径"
    }, null, 8, ["model-value"])])) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.images(question.questionImages), image => {
      return _openBlock(), _createElementBlock("img", {
        key: image,
        src: image,
        alt: "题目图片"
      }, null, 8, _hoisted_4);
    }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.images(question.optionImages), image => {
      return _openBlock(), _createElementBlock("img", {
        key: image,
        src: image,
        alt: "选项图片"
      }, null, 8, _hoisted_5);
    }), 128))], 64))]), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", null, "答案 " + _toDisplayString(question.rightAnswer), 1), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $event => _ctx.$emit('confirm', question.id)
    }, {
      default: _withCtx(() => [_createTextVNode("选择此题")]),
      _: 2
    }, 1032, ["onClick"])])]);
  }), 128)), $data.total > $data.pageSize ? (_openBlock(), _createBlock(_component_el_pagination, {
    key: 1,
    class: "pagination",
    background: "",
    layout: "prev, pager, next",
    "current-page": $data.page + 1,
    "page-size": $data.pageSize,
    total: $data.total,
    onCurrentChange: _cache[0] || (_cache[0] = value => {
      $data.page = value - 1;
      $options.fetchQuestions();
    })
  }, null, 8, ["current-page", "page-size", "total"])) : _createCommentVNode("", true)])), [[_directive_loading, $data.loading]])]);
}